export const UISelectType={
    None:0,
    BackgroundImage:1,
    VectorImage:2,
    Text:3
};
